import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Una pantalla nueva empieza por arriba.
 *
 * QUÉ PASABA, y lo vio Gabri el 16 de septiembre de 2026: desde el final del Manifiesto se
 * pulsa «Conoce los 6 sistemas Alpha» y la Metodología **abría por el sistema 06**. No era un
 * fallo de esa página: al cambiar de ruta, el navegador se queda donde estaba, y ese botón
 * está al final de una página larga. Caías a la misma altura en la página siguiente.
 *
 * Y NO ERA DE UNA PÁGINA, ERA DE TODAS. Seis pantallas —Academia, Contacto, Newsletter,
 * NewsletterArticle, LessonView y AulaLeccion— llevaban su propio `window.scrollTo(0, 0)`
 * escrito a mano en un efecto. Las otras cuarenta y siete rutas, no. O sea: la regla existía,
 * se cumplía **acordándose**, y acordarse no es un mecanismo. Ahora lo hace este componente
 * una vez para todas, y `tools/check_arriba.py` se pone rojo si alguien vuelve a escribirlo
 * en una página —porque volver a escribirlo significaría que el mecanismo no funciona, y
 * entonces lo que hay que arreglar es el mecanismo—.
 *
 * LAS DOS EXCEPCIONES SON LAS QUE HACEN QUE ESTO NO ESTORBE:
 *
 *   · **Si la dirección trae ancla, no se toca nada.** `/origen#valores` quiere ir a Valores,
 *     y cada página resuelve su propia ancla. Subir arriba primero sería pelearse con ella.
 *   · **Al volver atrás, tampoco.** El navegador guarda dónde estabas, y perder el sitio al
 *     dar a «atrás» es de las cosas que más molestan y menos se cuentan. `useNavigationType`
 *     distingue una navegación nueva (PUSH) de una vuelta (POP).
 */
export default function AlPrincipio() {
  const { pathname, hash } = useLocation();
  const comoLlego = useNavigationType();
  useEffect(() => {
    if (hash || comoLlego === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, hash, comoLlego]);
  return null;
}
